export default "__VITE_ASSET__CkJJeTmw__"